import e from "../../_mixins/use-theme.js";
import { createInjectionKey as o } from "../../_utils/vue/create-injection-key.js";
const t = Object.assign(Object.assign({}, e.props), {
  onPreviewPrev: Function,
  onPreviewNext: Function,
  showToolbar: {
    type: Boolean,
    default: !0
  },
  showToolbarTooltip: Boolean,
  renderToolbar: Function
}), i = o("n-image");
export {
  i as imageContextKey,
  t as imagePreviewSharedProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/image/src/interface.js
// module id = 468
// module chunks = 41